export const enum ROLE_TYPE {
  ADMIN = '0',
  MANAGER = '2',
  USER = '1',
}

export const enum PAGE_TYPE {
  ALL_PREV,
  PREV,
  NEXT,
  ALL_NEXT,
}

export const enum YN_TYPE {
  Y = 'Y',
  N = 'N',
}

export const enum STOCK_TYPE {
  S = 'S',
  U = 'U',
}

export const enum USER_LOG_TYPE {
  L = 'L',
  P = 'P',
  S = 'S',
  O = 'O',
}

export const enum LOCKER_STATE {
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
  CONNECT = 'CONNECT',
}

export const enum DEVICE_MODAL_TYPE {
  FACTORY = 'factory',
  PART = 'part',
  AREA = 'zone',
  SECTION = 'section',
  DEVICE = 'equip',
}

export const enum MV_CODE {
  Z101 = 'Z101',
  Z201 = 'Z201',
}

export const enum ACTION_TYPE {
  REGISTER,
  UPDATE,
}

export const enum STATISTICS_TYPE {
  DASHBOARD = 1,
  LOTO_STATUS = 2,
  LOTO_HISTORY = 3,
  ORDER_MANAGE = 4,
  LOTO_SETTING = 5,
  LOTO_BOX_OPEN = 6,
  LOTO_REGISTER = 7,
  ORDER_TA = 8,
  ORDER_TRANSFER = 9,
  ORDER_HISTORY = 10,
  EQUIP_MANAGE = 11,
  FACTORY = 12,
  AREA = 13,
  ZONE = 14,
  EQUIP = 15,
  LOCKER_MANAGE = 16,
  USER_MANAGE = 17,
  AUTH_MANAGE = 18,
}

export const enum VCM_LOCK_TYPE {
  SET = 0,
  LOCK = 1,
  UNLOCK = 2,
}

export const enum LOG_MEMO_TYPE {
  LOCK = 'LOCK',
  TAG = 'TAG'
}
